const ADMIN_API_URL =
  import.meta.env.VITE_ADMIN_API_URL ||
  import.meta.env.EXPO_PUBLIC_ADMIN_API_URL ||
  '';

export const getAdminApiUrl = () => {
  if (!ADMIN_API_URL) {
    console.warn('Admin API URL not configured');
    return '';
  }
  return ADMIN_API_URL.replace(/\/$/, '');
};

export const adminApiUrl = getAdminApiUrl();

